/* Uses the same Eastern cutoff as Shopify's automatic discount. */
(function () {
  var end = Date.parse('2026-10-31T23:59:00-04:00');
  var expired = false;
  function tick() {
    var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
    var vals = { days: Math.floor(left / 86400), hours: Math.floor(left / 3600) % 24, minutes: Math.floor(left / 60) % 60, seconds: left % 60 };
    document.querySelectorAll('[data-oct-time]').forEach(function(el) { el.textContent = String(vals[el.dataset.octTime]).padStart(2, '0'); });
    if (Date.now() >= end && !expired) {
      expired = true;
      document.querySelectorAll('[data-october-offer],.oct-price-badge,.oct-announcement').forEach(function(el) { el.hidden = true; });
      document.querySelectorAll('[data-october-fallback]').forEach(function(el) { el.hidden = false; });
      document.dispatchEvent(new CustomEvent('fizzy:october-expired'));
      window.dispatchEvent(new Event('resize'));
      clearInterval(timer);
    }
  }
  var timer = setInterval(tick, 1000);
  tick();
  document.addEventListener('visibilitychange', function() { if (!document.hidden) tick(); });
})();
